<template>
  <div class="report_container">
    <div v-if="dataList && !loading">
      <header>
        <img src="../../assets/img/logo-trustlook.png" alt="" @click="jump('/dashboard')" />
      </header>
      <h3 class="title">Report</h3>
      <div class="main1">
        <div>
          <img :src="dataList.app_icon" alt="" v-if="dataList.app_icon" class="app_logo" />
          <table v-if="dataList.summary">
            <tr class="tip">
              <td class="tit">App name</td>
              <td class="txt">{{ dataList.summary.app_name }}</td>
            </tr>
            <tr class="tip">
              <td class="tit">Virus name</td>
              <td class="txt">{{ dataList.summary.virus_name }}</td>
            </tr>
            <tr class="tip">
              <td class="tit">Virus score</td>
              <td class="txt">{{ dataList.summary.score }}</td>
            </tr>
            <tr class="tip">
              <td class="tit">MD5</td>
              <td class="txt">{{ dataList.summary.md5 }}</td>
            </tr>
            <tr class="tip">
              <td class="tit">SHA1</td>
              <td class="txt">{{ dataList.summary.sha1 }}</td>
            </tr>
            <tr class="tip">
              <td class="tit">SHA256</td>
              <td class="txt">{{ dataList.summary.sha256 }}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="main2">
        <ul class="tit_list">
          <li :class="active === 0 ? 'active' : ''" @click="active = 0">Summary</li>
          <li :class="active === 1 ? 'active' : ''" @click="active = 1">Dynamic behavior</li>
          <li :class="active === 2 ? 'active' : ''" @click="active = 2">Additional information</li>
        </ul>
        <div class="main2_content" v-if="active === 0">
          <div class="screen_content" v-if="dataList.all_screen_shot">
            <h4>ALL SCREENSHOTS</h4>
            <ul>
              <li
                v-for="(item, index1) in dataList.all_screen_shot"
                :key="index1"
                @click="index = index1"
              >
                <img :src="item" alt="" />
              </li>
            </ul>
            <gallery
              :images="dataList.all_screen_shot"
              :index="index"
              @close="index = null"
            ></gallery>
          </div>
          <div class="risky_content">
            <h4>OTHER RISKY FEATURES</h4>
            <ul class="list">
              <li>
                <div>
                  <span>Name</span>
                  <span>Severity level</span>
                  <span>Evidence</span>
                </div>
              </li>
              <li v-for="(item, index) in listRisky" :key="index">
                <div>
                  <span>{{ item.desc_en }}</span>
                  <span>{{ item.severity }}</span>
                  <span>
                    <p v-for="(ditem, dindex) in item.evidence_en" :key="dindex">{{ ditem }}</p>
                  </span>
                </div>
              </li>
            </ul>
          </div>
          <div class="packer_content">
            <h4>PACKER <i class="el-icon-info" @click="iptStatus = !iptStatus"></i></h4>
            <div class="logs" v-show="iptStatus">
              Application encryption and obfuscation.
            </div>
            <p v-if="dataList.full_report && dataList.full_report.packer">
              {{ dataList.full_report.packer.packer_id }}
            </p>
          </div>
        </div>
        <div class="main2_content" v-if="active === 1">
          <div class="behavior_content1" v-if="dataList.summary && dataList.summary.risk_summary">
            <h4>
              BEHAVIOR SUMMARY <i class="icon-info-i" @click="summaryStatus = !summaryStatus"></i>
            </h4>
            <div v-if="summaryStatus">
              <div class="logs">
                Summary of notable app behaviors and their corresponding risk levels. The list is
                ordered by risk score, with the most malicious and risky behaviors listed on top.
              </div>
              <p>
                <span class="color1">Critical: </span>Mostly called by malware. An indicator of
                malware.
              </p>
              <p>
                <span class="color2">Dangerous: </span>Frequently called by malware. Appear in many
                malware.
              </p>
              <p>
                <span class="color3">Risky: </span> Suspicious behavior, appeared in some malware.
              </p>
              <p>
                <span class="color4">Normal: </span>General behavior. Not specific to any malware.
              </p>
            </div>
            <div class="list_content">
              <table class="list">
                <tr v-for="(item0, index0) in arr0" :key="index0" class="li0">
                  {{
                    item0.desc_en
                  }}
                </tr>
                <tr v-for="(item1, index1) in arr1" :key="index1" class="li1">
                  {{
                    item1.desc_en
                  }}
                </tr>
                <tr v-for="(item2, index2) in arr2" :key="index2" class="li2">
                  {{
                    item2.desc_en
                  }}
                </tr>
                <tr v-for="(item3, index3) in arr3" :key="index3" class="li3">
                  {{
                    item3.desc_en
                  }}
                </tr>
              </table>
            </div>
          </div>
          <div v-if="dataList.full_report">
            <div class="behavior_content2" v-if="dataList.full_report.logs">
              <h4>BEHAVIOR LOGS <i class="el-icon-info" @click="logStatus = !logStatus"></i></h4>
              <div class="logs" v-show="logStatus">
                The Behavior Logs is one of the most important parts of a report. It shows what the
                app is doing within the rst couple of seconds of the app running. For each behavior,
                the corresponding Android function call will be listed, such as a call for a le,
                URL, phone number, and more.
              </div>
              <el-table
                class="behavior_table"
                :data="listLog"
                :header-cell-style="rowClass"
                :empty-text="emptyText"
              >
                <el-table-column type="index" :index="indexMethod" width="100"></el-table-column>
                <el-table-column property="time" label="Time" width="100"></el-table-column>
                <el-table-column
                  property="message"
                  label="Behavior"
                  min-width="500"
                ></el-table-column>
              </el-table>

              <div class="block">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="currentPage1"
                  :page-size="10"
                  layout="prev, pager, next"
                  :total="dataList.full_report.logs.length"
                >
                </el-pagination>
              </div>
            </div>
            <div class="receivers_content" v-if="dataList.full_report.receivers">
              <h4>
                RECEIVERS <i class="el-icon-info" @click="receiversStatus = !receiversStatus"></i>
              </h4>
              <div class="logs" v-show="receiversStatus">
                These are system events that this app monitors and makes use of. Look for events
                that are not consistent with the app’s purpose (e.g. Flashlight app looking for
                SMS_RECEIVED)
              </div>
              <div
                class="list"
                v-for="(item, index) in dataList.full_report.receivers"
                :key="index"
              >
                <table>
                  <tr class="li_tit">
                    {{
                      index
                    }}
                  </tr>
                  <tr v-for="(ditem, dindex) in item" :key="dindex" class="li_txt">
                    {{
                      ditem
                    }}
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="main2_content" v-if="active === 2 && dataList.full_report">
          <div class="permissions_content" v-if="dataList.full_report.permissions">
            <h4>
              PERMISSIONS LIST
              <i class="el-icon-info" @click="permissionsStatus = !permissionsStatus"></i>
            </h4>
            <div class="logs" v-show="permissionsStatus">
              These are permissions secured by the app and the risk level for these permissions.
              Beware of extra permissions not required by normal app behavior. List is ordered by
              risk score, with the most dangerous listed on top.
            </div>
            <div class="list_content">
              <table class="list">
                <tr>
                  <div class="tr_div">
                    <td class="li_name">Name</td>
                    <td class="li_desc">Description</td>
                  </div>
                </tr>
                <tr v-for="(item, index) in dataList.full_report.permissions" :key="index">
                  <div class="tr_div">
                    <td class="li_name">{{ index }}</td>
                    <td class="li_desc">
                      <span>{{ item[1] }}</span
                      ><i class="el-icon-info" @mouseenter="show(index)" @mouseleave="show(-1)"></i>
                    </td>
                    <div class="li_txt" v-if="index === i">
                      {{ item[2] || '' }}
                    </div>
                  </div>
                </tr>
              </table>
            </div>
          </div>
          <div class="app_content" v-if="dataList.full_report.certificate">
            <h4 class="spec_h">
              APP CERTIFICATE <i class="el-icon-info" @click="appStatus = !appStatus"></i>
            </h4>
            <div class="logs" v-show="appStatus">
              In addition to the MD5 and SHA numbers, the App Certificate identifies the date the
              app was created, from which country it originated, and whether or not the certificate
              is still active.
            </div>
            <div class="list_content">
              <table class="list">
                <tr>
                  <div>
                    <td class="li_left">MD5</td>
                    <td class="li_right">{{ dataList.full_report.certificate.md5 }}</td>
                  </div>
                </tr>
                <tr>
                  <div>
                    <td class="li_left">SHA1</td>
                    <td class="li_right">{{ dataList.full_report.certificate.sha1 }}</td>
                  </div>
                </tr>
                <tr>
                  <div>
                    <td class="li_left">Serial number</td>
                    <td class="li_right">{{ dataList.full_report.certificate.serialnum }}</td>
                  </div>
                </tr>
                <tr>
                  <div>
                    <td class="li_left">Pem</td>
                    <td class="li_right pem_right">
                      -----BEGIN CERTIFICATE----- <br /><span class="spec">{{
                        formatStr(dataList.full_report.certificate.pem)
                      }}</span
                      ><br />-----END CERTIFICATE-----
                    </td>
                  </div>
                </tr>
                <tr>
                  <div>
                    <td class="li_left">Issuer</td>
                    <td class="li_right">{{ dataList.full_report.certificate.issuer.DN }}</td>
                  </div>
                </tr>
                <tr>
                  <div>
                    <td class="li_left">Subject</td>
                    <td class="li_right">{{ dataList.full_report.certificate.subject.DN }}</td>
                  </div>
                </tr>
                <tr>
                  <div>
                    <td class="li_left">Issue Date</td>
                    <td class="li_right">{{ dataList.full_report.certificate.issueday }}</td>
                  </div>
                </tr>
                <tr>
                  <div>
                    <td class="li_left">Expire Date</td>
                    <td class="li_right">{{ dataList.full_report.certificate.expireday }}</td>
                  </div>
                </tr>
                <tr>
                  <div>
                    <td class="li_left">Expired</td>
                    <td class="li_right">{{ dataList.full_report.certificate.isexpired }}</td>
                  </div>
                </tr>
              </table>
            </div>
          </div>
          <div class="activities_content">
            <h4>
              ACTIVITIES <i class="el-icon-info" @click="activitiesStatus = !activitiesStatus"></i>
            </h4>
            <div class="logs" v-show="activitiesStatus">
              Activities list what activities are requested within the app. The example below shows
              that this app uses an SMS Opt-In activity.
            </div>
            <div class="list_div">
              <table class="list">
                <tr v-for="(item, index) in listActivities" :key="index">
                  {{
                    item
                  }}
                </tr>
              </table>

              <div class="block">
                <el-pagination
                  @current-change="handleCurrentChange2"
                  :current-page="currentPage2"
                  :page-size="10"
                  layout="prev, pager, next"
                  :total="dataList.full_report.activities.length"
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <div class="activities_content">
            <h4>SERVICES <i class="el-icon-info" @click="servicesStatus = !servicesStatus"></i></h4>
            <div class="logs" v-show="servicesStatus">
              Services lists additional services that are included in the app. The example below
              shows this app includes an SMS and Pay service.
            </div>
            <div class="list_div">
              <table class="list">
                <tr v-for="(item, index) in listServices" :key="index">
                  {{
                    item
                  }}
                </tr>
              </table>

              <div class="block">
                <el-pagination
                  @current-change="handleCurrentChange3"
                  :current-page="currentPage3"
                  :page-size="10"
                  layout="prev, pager, next"
                  :total="dataList.full_report.services.length"
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <div class="files_content" v-if="dataList.full_report">
            <h4>ELF FILES <i class="el-icon-info" @click="filesStatus1 = !filesStatus1"></i></h4>
            <div class="logs" v-show="filesStatus1">
              ELF Files are the individual Executable Linkable Format files inside the APK
            </div>
            <div class="list_content">
              <table class="list">
                <tr>
                  <div>
                    <td class="li_left">Name</td>
                    <td class="li_right">
                      <span>Type</span>
                      <span></span>
                    </td>
                  </div>
                </tr>
                <tr v-for="(item, index) in listFiles1">
                  <div v-for="(ditem, dindex) in item" :key="dindex">
                    <td class="li_left">{{ dindex }}</td>
                    <td class="li_right">
                      <span>so</span>
                      <i
                        class="el-icon-info"
                        @mouseenter="show2(dindex)"
                        @mouseleave="show2(-1)"
                      ></i>
                    </td>
                    <div class="li_txt" v-if="txt2 === dindex">{{ ditem }}</div>
                  </div>
                </tr>
              </table>

              <div class="block">
                <el-pagination
                  @current-change="handleCurrentChange4"
                  :current-page="currentPage4"
                  :page-size="10"
                  layout="prev, pager, next"
                  :total="file1List.length"
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <div class="files_content">
            <h4>FILES <i class="el-icon-info" @click="filesStatus2 = !filesStatus2"></i></h4>
            <div class="logs" v-show="filesStatus2">
              Files are the individual les inside the APK, such as jar les or mp3s.
            </div>
            <div class="list_content">
              <table class="list">
                <tr>
                  <div>
                    <td class="li_left">Name</td>
                    <td class="li_right">
                      <span>Type</span>
                      <span></span>
                    </td>
                  </div>
                </tr>
                <tr v-for="(item, index) in listFiles2">
                  <div v-for="(ditem, dindex) in item" :key="dindex">
                    <td class="li_left">{{ dindex }}</td>
                    <td class="li_right">
                      <span>{{ format(dindex) }}</span>
                      <i
                        class="el-icon-info"
                        @mouseenter="show3(dindex)"
                        @mouseleave="show3(-1)"
                      ></i>
                    </td>
                    <div class="li_txt" v-if="txt3 === dindex">{{ ditem }}</div>
                  </div>
                </tr>
              </table>

              <div class="block">
                <el-pagination
                  @current-change="handleCurrentChange5"
                  :current-page="currentPage5"
                  :page-size="10"
                  layout="prev, pager, next"
                  :total="Object.keys(dataList.full_report.files).length"
                >
                </el-pagination>
              </div>
            </div>
          </div>
          <div class="strings_content" v-if="dataList.full_report.suspicious_strings">
            <h4>
              POTENTIALLY RISKY STRINGS
              <i class="el-icon-info" @click="stringStatus = !stringStatus"></i>
            </h4>
            <div class="logs" v-show="stringStatus">
              Potentially Risky Strings are the files or URLs that may do harm to your device.
            </div>
            <div class="list_content">
              <table class="list">
                <tr>
                  <div>
                    <td class="li_left">Path/URL</td>
                    <td class="li_right">Type</td>
                  </div>
                </tr>
                <tr v-for="(item, index) in listStrings" :key="index">
                  <div v-for="(ditem, dindex) in item">
                    <td class="li_left">{{ dindex }}</td>
                    <td class="li_right">{{ ditem }}</td>
                  </div>
                </tr>
              </table>

              <div class="block">
                <el-pagination
                  @current-change="handleCurrentChange6"
                  :current-page="currentPage6"
                  :page-size="10"
                  layout="prev, pager, next"
                  :total="Object.keys(dataList.full_report.suspicious_strings).length"
                >
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        © Trustlook .Inc
      </div>
    </div>
    <loading2 :show="loading"></loading2>
  </div>
</template>

<script>
import axios from 'axios'
import { Message } from 'element-ui'
import loading2 from '../../components/loading2'
import SummaryList from '../public/summaryList'
import VueGallery from 'vue-gallery'
import VueRouter from 'vue-router'

const { isNavigationFailure, NavigationFailureType } = VueRouter

export default {
  name: 'APPInsightDetail',
  components: { loading2, gallery: VueGallery },
  data() {
    return {
      link: this.$route.query.link,
      dataList: {},
      loading: true,
      active: 0,
      packer_txt: '',
      iptStatus: false,
      summaryStatus: false,
      logStatus: false,
      permissionsStatus: false,
      receiversStatus: false,
      appStatus: false,
      activitiesStatus: false,
      servicesStatus: false,
      stringStatus: false,
      filesStatus1: false,
      filesStatus2: false,
      currentPage1: 1,
      currentPage2: 1,
      currentPage3: 1,
      currentPage4: 1,
      currentPage5: 1,
      currentPage6: 1,
      list: [],
      listLog: [],
      list2: [],
      listActivities: [],
      list3: [],
      listServices: [],
      list4: [],
      listFiles1: [],
      list5: [],
      listFiles2: [],
      list6: [],
      listStrings: [],
      list7: [],
      listRisky: [],
      file1List: [],
      list8: [],
      arr0: [],
      arr1: [],
      arr2: [],
      arr3: [],
      i: -1,
      txt2: -1,
      txt3: -1,
      index: null
    }
  },
  methods: {
    indexMethod(index) {
      return index + 10 * (this.currentPage1 - 1)
    },
    show(index) {
      this.i = index
    },
    show2(index) {
      this.txt2 = index
    },
    show3(index) {
      this.txt3 = index
    },
    format(val) {
      var strArray = val.split('.')
      return strArray[strArray.length - 1]
    },
    getReport() {
      axios
        .get(this.link)
        .then(res => {
          this.dataList = res.data
          this.loading = false
          this.list = this.dataList.full_report.logs
          this.list2 = this.dataList.full_report.activities
          this.list3 = this.dataList.full_report.services
          this.list4 = this.dataList.full_report.elf_files
          this.list5 = this.dataList.full_report.files
          this.list6 = this.dataList.full_report.suspicious_strings
          this.list7 = this.dataList.eval_list
          this.list8 = this.dataList.summary.risk_summary
          this.getDataList(1)
          this.getActivitiesList(1)
          this.getServicesList(1)
          this.getFileList1(1)
          this.getFileList2(1)
          this.getStringsList(1)
          this.getRiskyList()
          this.getSummaryList()
        })
        .catch(err => {
          this.loading = false
        })
    },
    getDataList(val) {
      this.listLog = []
      this.list.map((item, index) => {
        if (index >= 10 * (val - 1) && index <= 10 * val - 1) {
          this.listLog.push(item)
        }
      })
    },
    getActivitiesList(val) {
      this.listActivities = []
      this.list2.map((item, index) => {
        if (index >= 10 * (val - 1) && index <= 10 * val - 1) {
          this.listActivities.push(item)
        }
      })
    },
    getServicesList(val) {
      this.listServices = []
      this.list3.map((item, index) => {
        if (index >= 10 * (val - 1) && index <= 10 * val - 1) {
          this.listServices.push(item)
        }
      })
    },
    getFileList1(val) {
      this.listFiles1 = []
      for (var i in this.list4) {
        var o = {}
        o[i] = this.list4[i]
        var strArray = i.split('.')
        if (strArray[strArray.length - 1] === 'so') {
          this.listFiles1.push(o)
        }
      }
      this.file1List = this.listFiles1
      var arr = []
      this.listFiles1.map((item, index) => {
        if (index >= 10 * (val - 1) && index <= 10 * val - 1) {
          arr.push(item)
        }
      })
      this.listFiles1 = arr
    },
    getFileList2(val) {
      this.listFiles2 = []
      for (var i in this.list5) {
        var o = {}
        o[i] = this.list5[i]
        this.listFiles2.push(o)
      }
      var arr = []
      this.listFiles2.map((item, index) => {
        if (index >= 10 * (val - 1) && index <= 10 * val - 1) {
          arr.push(item)
        }
      })
      this.listFiles2 = arr
    },
    getStringsList(val) {
      this.listStrings = []
      for (var i in this.list6) {
        var o = {}
        o[i] = this.list6[i]
        this.listStrings.push(o)
      }
      var arr = []
      this.listStrings.map((item, index) => {
        if (index >= 10 * (val - 1) && index <= 10 * val - 1) {
          arr.push(item)
        }
      })
      this.listStrings = arr
    },
    getRiskyList() {
      for (var i in this.list7) {
        var o = {}
        o[i] = this.list7[i]
        if (o[i].eval_result_code === 'EVAL_SUSPICIOUS') {
          this.listRisky.push(o)
        }
      }
      let arr = []
      this.listRisky.map(item => {
        for (let i in item) {
          arr.push(item[i].violations)
        }
      })
      let brr = []
      arr.map(ditem => {
        for (let j in ditem) {
          brr.push(ditem[j])
        }
      })
      this.listRisky = brr
    },
    getSummaryList() {
      this.arr0 = []
      this.arr1 = []
      this.arr2 = []
      this.arr3 = []
      this.list8.map(item => {
        for (var i in SummaryList) {
          if (item === SummaryList[i].name) {
            if (SummaryList[i].count === 0) {
              this.arr0.push(SummaryList[i])
            }
            if (SummaryList[i].count === 1) {
              this.arr1.push(SummaryList[i])
            }
            if (SummaryList[i].count === 2) {
              this.arr2.push(SummaryList[i])
            }
            if (SummaryList[i].count === 3) {
              this.arr3.push(SummaryList[i])
            }
          }
        }
      })
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage1 = val
      this.getDataList(val)
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val
      this.getActivitiesList(val)
    },
    handleCurrentChange3(val) {
      this.currentPage3 = val
      this.getServicesList(val)
    },
    handleCurrentChange4(val) {
      this.currentPage4 = val
      this.getFileList1(val)
    },
    handleCurrentChange5(val) {
      this.currentPage5 = val
      this.getFileList2(val)
    },
    handleCurrentChange6(val) {
      this.currentPage6 = val
      this.getStringsList(val)
    },
    jump(url) {
      this.$router.push(url).catch(err => {
        // to hide the below error message
        if (!isNavigationFailure(err, NavigationFailureType.duplicated)) {
          throw Error(err)
        }
      })
    },
    formatStr(str) {
      let brr = ''
      brr = str.replace(/[↵]/g, '')
      brr = brr.replace('-----BEGIN CERTIFICATE-----', '')
      brr = brr.replace('-----END CERTIFICATE-----', '')
      return brr
    }
  },
  mounted() {
    this.getReport()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-icon-info {
  color: #999;
}
header {
  background: #1f253e;
  padding: 10px 25px;
  & > img {
    width: 150px;
    cursor: pointer;
  }
}
.title {
  padding: 25px 25px;
  margin-bottom: 25px;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.5);
  border-bottom: 1px solid #e4e7ea;
}
.main1 {
  margin: 0 25px 20px;
  background: #fff;
  padding: 25px;
  & > div {
    overflow-x: auto;
  }
  .app_logo {
    display: block;
    width: 48px;
    margin-bottom: 10px;
    padding: 0 8px;
  }
  table {
    width: 100%;
    .tip {
      display: block;
      white-space: nowrap;
      height: 45px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-bottom: 1px solid #e4e7ea;
      font-size: 14px;
      color: #797979;
      .tit {
        display: inline-block;
        max-width: 211px;
        min-width: 100px;
        width: 30%;
        padding: 0 8px;
        box-sizing: border-box;
      }
      &:last-child {
        border: none;
      }
      .txt {
        display: inline-block;
        width: 70%;
      }
    }
  }
}
.main2 {
  margin: 0 25px;
  background: #fff;
  padding: 25px;
  .tit_list {
    display: flex;
    li {
      padding: 10px 15px;
      color: #3e4d6c;
      font-size: 14px;
      margin-right: 4px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
    .active {
      background: #008efa;
      color: #ffffff;
      border-radius: 3px;
      cursor: default;
      &:hover {
        background: #008efa;
      }
    }
  }
  .main2_content {
    ::v-deep .el-icon-info {
      cursor: pointer;
      margin-left: 5px;
    }
    h4 {
      font-size: 14px;
      color: #2b2b2b;
      line-height: 30px;
      margin-bottom: 10px;
      padding-top: 30px;
      border-top: 1px solid #e4e7ea;
      margin-top: 40px;
    }
    .spec_h {
      margin-top: 0;
    }
    .logs {
      width: 100%;
      padding: 15px;
      box-sizing: border-box;
      font-size: 14px;
      color: #686868;
      margin-bottom: 20px;
      border: 1px solid #e4e7ea;
      box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
      border-radius: 3px;
    }
    .screen_content {
      & > ul {
        display: flex;
        flex-wrap: wrap;
        & > li {
          width: 187px;
          padding: 10px 0;
          margin-bottom: 20px;
          & > img {
            display: block;
            width: 100px;
            margin: 0 auto;
          }
          &:hover {
            border: 1px solid #e4e7ea;
            cursor: pointer;
          }
        }
      }
    }
    .risky_content {
      .list {
        & > li {
          & > div {
            display: flex;
            justify-content: flex-start;
            border-top: 1px solid #e4e7ea;
            color: #797979;
            & > span {
              display: block;
              padding: 12px 8px;
              word-break: break-word;
              box-sizing: border-box;
              &:first-child {
                width: 40%;
              }
              &:nth-child(2) {
                width: 10%;
                min-width: 70px;
              }
              &:nth-child(3) {
                width: 40%;
              }
            }
          }
          &:first-child > div {
            border-top: none;
            color: #666;
            font-weight: 900;
          }
        }
      }
    }
    .packer_content {
      & > p {
        font-size: 14px;
        color: #686868;
      }
    }
    .behavior_content1 {
      p {
        font-size: 14px;
        color: #686868;
        margin-bottom: 10px;
      }
      .color1 {
        color: #f75b36;
      }
      .color2 {
        color: #f8c255;
      }
      .color3 {
        color: #008efa;
      }
      .color4 {
        color: #00c292;
      }
      .list_content {
        overflow-x: auto;
      }
      .list {
        width: 100%;
        & > tr {
          display: block;
          font-size: 14px;
          box-sizing: border-box;
          padding: 12px 8px;
          border-bottom: 1px solid #e4e7ea;
          white-space: nowrap;
        }
      }
      .li0 {
        background-color: #f2dede;
        color: #a94442;
      }
      .li1 {
        background-color: #fcf8e3;
        color: #8a6d3b;
      }
      .li2 {
        background-color: #d9edf7;
        color: #31708f;
      }
      .li3 {
        background-color: #dff0d8;
        color: #3c763d;
      }
      .li3:last-child {
        border-bottom: none;
      }
    }
    .receivers_content {
      .list {
        overflow-x: auto;
        & > table {
          width: 100%;
          font-size: 14px;
          & > tr {
            display: block;
            white-space: nowrap;
          }
          .li_tit {
            padding: 12px 8px;
            color: #666;
            font-weight: 900;
          }
          .li_txt {
            padding: 12px 8px;
            border-top: 1px solid #e4e7ea;
            color: #797979;
          }
        }
      }
    }
    .permissions_content {
      .list_content {
        overflow-x: auto;
        padding-bottom: 40px;
      }
      .list {
        width: 100%;
        & > tr {
          display: block;
          border-top: 1px solid #e4e7ea;
          white-space: nowrap;
          font-size: 14px;
          color: #797979;
          .tr_div {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            white-space: nowrap;
            position: relative;
            & > td {
              display: block;
              padding: 12px 8px;
              box-sizing: border-box;
            }
            .li_name {
              width: 50%;
              min-width: 400px;
            }
            .li_desc {
              width: 50%;
              display: flex;
              justify-content: space-between;
              min-width: 300px;
            }
            .li_txt {
              background: #008efa;
              color: #fff;
              font-size: 14px;
              padding: 12px 8px;
              width: 200px;
              position: absolute;
              right: 30px;
              bottom: -10px;
              border-radius: 8px;
              text-align: center;
              z-index: 399;
              white-space: normal;
            }
          }
          &:first-child {
            color: #666;
            font-weight: 900;
            border-top: none;
          }
        }
      }
    }
    .app_content {
      .list_content {
        overflow-x: auto;
      }
      .list {
        width: 100%;
        & > tr {
          display: block;
          border-top: 1px solid #e4e7ea;
          white-space: nowrap;
          & > div {
            display: flex;
            justify-content: flex-start;
            white-space: nowrap;
            font-size: 14px;
            color: #797979;
            .li_left {
              padding: 12px 8px;
              min-width: 130px;
              width: 30%;
              box-sizing: border-box;
            }
            .li_right {
              min-width: 500px;
              width: 70%;
              box-sizing: border-box;
              padding: 12px 8px;
            }
            .pem_right {
              white-space: normal;
              width: 500px;
              .spec {
                word-break: break-all;
              }
            }
          }
        }
      }
    }
    .activities_content {
      .list_div {
        width: 100%;
        overflow-x: auto;
      }
      .list {
        width: 100%;
        & > tr,
        & > li {
          display: block;
          font-size: 14px;
          color: #797979;
          border-top: 1px solid #e4e7ea;
          padding: 12px 8px;
          list-style: none;
          white-space: nowrap;
        }
      }
    }
    .files_content {
      .list_content {
        overflow-x: auto;
        padding-bottom: 10px;
      }
      .list {
        width: 100%;
        & > tr {
          display: block;
          white-space: nowrap;
          border-top: 1px solid #e4e7ea;
          & > div {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: relative;
            color: #797979;
            font-size: 14px;
            white-space: nowrap;
            .li_left {
              width: 60%;
              padding: 12px 8px;
              box-sizing: border-box;
              min-width: 400px;
            }
            .li_right {
              width: 40%;
              padding: 12px 8px;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: space-between;
              min-width: 120px;
            }
            .li_txt {
              background: #008efa;
              color: #fff;
              font-size: 14px;
              padding: 12px 8px;
              width: 200px;
              position: absolute;
              right: 30px;
              bottom: -10px;
              border-radius: 8px;
              text-align: center;
              z-index: 399;
              white-space: normal;
            }
          }
          &:first-child {
            border-top: none;
            & > div {
              color: #666;
              font-weight: 900;
            }
          }
        }
      }
    }
    .strings_content {
      .list_content {
        overflow-x: auto;
      }
      .list {
        width: 100%;
        & > tr {
          display: block;
          white-space: nowrap;
          border-top: 1px solid #e4e7ea;
          & > div {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            font-size: 14px;
            color: #797979;
            .li_left {
              padding: 12px 8px;
              width: 60%;
              box-sizing: border-box;
              word-break: break-word;
              min-width: 300px;
            }
            .li_right {
              padding: 12px 8px;
              box-sizing: border-box;
              width: 40%;
              word-break: break-word;
              min-width: 160px;
            }
          }
        }

        & > tr:first-child {
          border-top: none;
          & > div {
            color: #666;
            font-weight: 900;
          }
        }
      }
    }
  }
}
.footer {
  width: 100%;
  height: 80px;
  font-size: 12px;
  border-top: 1px solid rgba(210, 220, 245, 1);
  box-sizing: border-box;
  padding: 20px 43px 0;
  font-weight: 600;
  margin-top: 40px;
  @include flex-end-center;
  z-index: 999;
  text-align: right;
  color: rgba(28, 28, 28, 1);
  font-family: NexaBold;
}
@media screen and (max-width: 850px) {
  ::v-deep .el-pagination {
    white-space: normal;
  }
  .main1 {
    & > div {
      border: 1px solid #e4e7ea;
    }
    .app_logo {
      margin-bottom: 0;
      padding: 10px 8px;
    }
    table {
      .tip {
        .tit {
          width: 100px;
        }
        .txt {
          flex: 1;
        }
      }
    }
  }
  .main2 {
    .main2_content {
      .activities_content .list_div,
      .permissions_content .list_content,
      .app_content .list_content,
      .files_content .list_content,
      .strings_content .list_content {
        border: 1px solid #e4e7ea;
      }
      .receivers_content .list {
        border: 1px solid #e4e7ea;
        margin-bottom: 15px;
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .main2 {
    .tit_list {
      & > li {
        display: flex;
        align-items: center;
      }
    }
    .main2_content {
      .screen_content {
        & > ul {
          & > li {
            width: 50%;
            box-sizing: border-box;
            & > img {
              display: block;
              width: 60%;
              margin: 0 auto;
            }
          }
        }
      }
      .behavior_content2 {
        .behavior_table {
          border: 1px solid #e4e7ea;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/service/appInsightDetail.vue